import { render, staticRenderFns } from "./Manager.component.html?vue&type=template&id=be5d8516&scoped=true&"
import script from "./Manager.component.ts?vue&type=script&lang=ts&"
export * from "./Manager.component.ts?vue&type=script&lang=ts&"
import style0 from "./Manager.component.scss?vue&type=style&index=0&id=be5d8516&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5d8516",
  null
  
)

export default component.exports